module.exports = __webpack_public_path__ + "img/password-cannot.550957f4.png";